import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGithub, FaLinkedin } from 'react-icons/fa';
import AuroraBackground from './AuroraBackground';
import ParticleBackground from './ParticleBackground';
import portfolioData from '../data/portfolio.json';
import MagneticButton from './MagneticButton';
import './Contact.css';

const Contact = () => {
    const profile = portfolioData.profile;

    const handleGmail = () => {
        // Opens Gmail compose window with your email pre-filled
        const email = profile?.email || 'vasudevkishor@gmail.com';
        const subject = encodeURIComponent('Portfolio Contact');
        const body = encodeURIComponent('Hi Vasudev,\n\n');
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
        window.open(gmailLink, '_blank');
    };

    const contactInfo = [
        {
            icon: <FaEnvelope />,
            title: 'Email',
            value: profile?.email || 'vasudevkishor@gmail.com',
            link: `mailto:${profile?.email || 'vasudevkishor@gmail.com'}`
        },
        {
            icon: <FaPhone />,
            title: 'Phone',
            value: profile?.phone || '8137056579',
            link: `tel:${profile?.phone || '8137056579'}`
        },
        {
            icon: <FaMapMarkerAlt />,
            title: 'Location',
            value: profile?.location || 'Trivandrum, Kerala, India',
            link: null
        }
    ];

    const socialLinks = [
        {
            icon: <FaGithub />,
            name: 'GitHub',
            url: profile?.social_links?.github || 'https://github.com/VasudevKishor'
        },
        {
            icon: <FaLinkedin />,
            name: 'LinkedIn',
            url: profile?.social_links?.linkedin || 'https://www.linkedin.com/in/vasudevkishor/'
        }
    ];

    return (
        <div className="contact">
            <AuroraBackground />
            <ParticleBackground particleCount={30} />
            <div className="container">
                {/* Header */}
                <motion.section
                    className="contact-header"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h1 className="page-title">Get In Touch</h1>
                    <p className="page-subtitle">
                        I'm always interested in new opportunities and exciting projects. Let's discuss how we can work together!
                    </p>
                </motion.section>

                <div className="contact-content">
                    {/* Contact Information */}
                    <motion.section
                        className="contact-info-section"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <h2 className="section-title">Contact Information</h2>
                        <div className="contact-info-grid">
                            {contactInfo.map((info, index) => (
                                <motion.div
                                    key={index}
                                    className="contact-info-card"
                                    whileHover={{ scale: 1.05, y: -5 }}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                >
                                    <div className="contact-icon">
                                        {info.icon}
                                    </div>
                                    <div className="contact-details">
                                        <h3>{info.title}</h3>
                                        {info.link ? (
                                            <a href={info.link} className="contact-link">
                                                {info.value}
                                            </a>
                                        ) : (
                                            <span>{info.value}</span>
                                        )}
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </motion.section>

                    {/* Gmail Button & Social Links */}
                    <motion.section
                        className="contact-meet-section"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <h2 className="section-title">Let's Connect</h2>
                        <div className="meet-button-container">
                            <MagneticButton
                                onClick={handleGmail}
                                className="btn btn-primary meet-btn"
                            >
                                <FaEnvelope /> Send Email via Gmail
                            </MagneticButton>
                            <p className="meet-description">
                                Click to open Gmail and send me an email. I'll get back to you as soon as possible!
                            </p>

                            <div className="connect-social-links">
                                <h3>Or connect on</h3>
                                <div className="connect-social-buttons">
                                    <motion.a
                                        href={socialLinks[0].url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="connect-social-btn github-btn"
                                        whileHover={{ scale: 1.1, y: -3 }}
                                        whileTap={{ scale: 0.95 }}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4, delay: 0.6 }}
                                    >
                                        <FaGithub />
                                        <span>GitHub</span>
                                    </motion.a>
                                    <motion.a
                                        href={socialLinks[1].url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="connect-social-btn linkedin-btn"
                                        whileHover={{ scale: 1.1, y: -3 }}
                                        whileTap={{ scale: 0.95 }}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4, delay: 0.7 }}
                                    >
                                        <FaLinkedin />
                                        <span>LinkedIn</span>
                                    </motion.a>
                                </div>
                            </div>
                        </div>
                    </motion.section>
                </div>
            </div>
        </div>
    );
};

export default Contact; 